import { useMutation } from "@tanstack/react-query";
import type {
  CreateChatChannelCommandResult,
  CreateChatChannelRequest,
} from "Infrastructure/Api/Api";
import { postChatChannel } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (data: CreateChatChannelCommandResult) => void;
  onError?: (error: unknown) => void;
};

export const useCreateChatChannelMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation<
    CreateChatChannelCommandResult,
    unknown,
    CreateChatChannelRequest
  >({
    mutationFn: processResponseWithApiProblemDetails((data) =>
      postChatChannel(data),
    ),
    onSuccess,
    onError,
  });
